@import "../../variables.scss";

.timesheet__feedback {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(68, 136, 255, 0.05);
  padding: 1rem;
  border-radius: 2px;
  @media (max-width: $size-md) {
    background: rgba(0, 30, 83, 0.05);
  }
}

.timesheet__feedback_large {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: white;
  padding: 4rem;
  border-radius: 2px;
  background: rgba(68, 136, 255, 0.05);
  @media (max-width: $size-md) {
    padding: 2rem;
    width: 100vw;
  }
}
@media (max-width: 1199px) {
  .feedback__title {
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: center;
  }
}

.timesheet__feedback_title {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
}

.timesheet__feedback_subtitle {
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}

.timesheet__feedback_faces {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  margin: 1.5rem 0rem;
}

.timesheet__feedback_face {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
}

.timesheet__feedback_desc {
  opacity: 0;
  transition: opacity 0.25s;
}

.timesheet__feedback_face:hover .timesheet__feedback_desc {
  opacity: 1;
  display: initial;
}

.timesheet__feedback_textarea {
  resize: none;
  width: 85%;
  margin-top: 0px;
  margin-bottom: 1.5rem;
  height: 110px;
  border-color: rgb(209, 209, 209);
  border-radius: 4px;
}

.feedback__desc_picked {
  opacity: 1;
  font-size: 16px;
  line-height: 19px;
}

.feedback__desc_notpicked {
  opacity: 1;
  color: rgba(0, 0, 0, 0.25);
}

.timesheet__feedback_submit {
  background: #ffffff;
  border: 1px solid #48a4f5;
  box-sizing: border-box;
  border-radius: 4px;
  color: black;
}
